import { StorageEntry } from 'utils/storageEntry';

class StorageManager {
    // Invalidate the JWT after three hours
    // public for test purposes
    public static readonly jwtTTL: number = 3 * 60 * 60 * 1000;
    public static readonly accessTokenKey: string = '_accessJwt';
    private readonly _accessJwt: StorageEntry<string>;
    private readonly _localStorage: Storage;
    private readonly _sessionStorage: Storage;

    constructor(localStorage: Storage, sessionStorage: Storage) {
        this._localStorage = localStorage;
        this._sessionStorage = sessionStorage;
        this._accessJwt = new StorageEntry(sessionStorage, StorageManager.accessTokenKey, StorageManager.jwtTTL);
    }

    get jwt(): StorageEntry<string> {
        return this._accessJwt;
    }

    get localStorage(): Storage {
        return this._localStorage;
    }

    get sessionStorage(): Storage {
        return this._sessionStorage;
    }
}

export { StorageManager };
export default StorageManager;



// WEBPACK FOOTER //
// ./src/utils/storageManager.ts